import React from 'react';

import './assessment-header-content.scss';

const AssessmentHeaderContent = () => (
    <React.Fragment>
        <div className="assessment-header-content">
            <div className="assessment-header-content__info">
                <a className="assessment-header-content__title" target="_blank" rel="noreferrer" href="https://chally.com/request-a-sales-call/" >Chally Assessment</a>
            </div>
        </div>
    </React.Fragment>
);
AssessmentHeaderContent.propTypes = {
};

AssessmentHeaderContent.defaultProps = {
};

export default AssessmentHeaderContent;
